<template>
  <div class="wrap myoreders-wrap personal-wrap">
    <mu-infinite-scroll :loading="loadShow" loadingText="拼命加载中" class="load" v-if="loadShow" />
    <empty imgpath="/static/images/empty_address_3x.png" emptytext="您还没有添加收货地址" btntext="去添加" btnurl="/main/writeaddress" v-if="listAddressMsg.length==0 && !loadShow"></empty>
    <div class="flex-column address-list" v-if="listAddressMsg.length!=0 && !loadShow">
      <div class="flex-item">
        <div class="address-item" v-for="(listAddressShow, addressIndex) in listAddressMsg">
          <p class="address">{{listAddressShow.province}}&nbsp;&nbsp;{{listAddressShow.city}}&nbsp;&nbsp;{{listAddressShow.area}}&nbsp;&nbsp;{{listAddressShow.address}}</p>
          <p class="user">
            <label>{{listAddressShow.consignee}}</label>
            <label class="fr">{{listAddressShow.mobile}}</label>
          </p>
          <div class="operate">
            <mu-radio name="group" @change="changeCheck(listAddressShow.addressId,listAddressShow.isDefault)" :label="listAddressShow.isDefault== 1 ? '默认地址' : '设为默认'" :nativeValue="listAddressShow.addressId" v-model="defaultAddress" class="list-radio" v-bind:class="[listAddressShow.isDefault== 1 ? 'primary' : '']" />
            <p class="edit-address fr" @click="editAddress(listAddressShow.addressId,listAddressShow.memId)">编辑</p>
            <p class="delete-address fr" @click="deleteAddress(listAddressShow.addressId)">删除</p>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="bottom-btn-box">
        <div class="bottom-full-button">
          <mu-raised-button label="添加新地址" fullWidth primary @click="addAddress()" />
        </div>
      </div>
    </div>
    <mu-dialog :open="isDelete" title="删除地址" titleClass="dialogTitle" bodyClass="dialogBody" actionsContainerClass="dialogActionsContainer" @close="isDelete = false">
      确定删除这个地址？
      <mu-flat-button slot="actions" @click="isDelete = false" primary label="否" />
      <mu-flat-button slot="actions" primary label="确定" @click="closedeleteAddress()" />
    </mu-dialog>
    <mu-toast v-if="toast1" message="设置成功!" class="custom-toast" />
    <mu-toast v-if="toast2" message="删除成功!" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
import empty from '@components/empty/empty';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      loadShow: true,
      defaultAddress: "",
      isDelete: false, //删除弹框
      listAddressMsg: [], //所有收货地址
      addressId: '', //获取当前选中的地址
      toast1: false, //提示设置信息
      toast2: false, //删除成功提示
    }
  },
  methods: {
    ...mapActions({
      removeAddress: 'removeAddress', //删除收货地址
      addAddress: 'addAddress', //新增收货地址
      editAddress: 'editAddress', //修改收货地址
      listAreaMsg: 'listAreaMsg', //获取地域列表
      getAddress: 'getAddress', //获取地址列表
      listAddress: 'listAddress', //直接列出收货地址列表
      doSetDefaultAddress: 'doSetDefaultAddress', //设置为默认地址
    }),
    //修改地址
    editAddress(addressId, memId) {
      this.$router.push({
        path: '/main/writeaddress?addressId=' + addressId + '&memId=' + memId
      });
    },
    //删除地址
    deleteAddress(addressId) {
      this.addressId = addressId; //当前需要删除的Id
      this.isDelete = true;
    },
    //调用删除api 并关闭事件
    closedeleteAddress() {
      this.getRemoveAddress(this.addressId);
    },
    //设置默认地址按钮
    changeCheck(addressId, isDefault) {
      if (isDefault == 0) {
        console.log("状态:", addressId + "获取的地址" + isDefault);
        this.getDoSetDefaultAddress(addressId, 1);
      } else if (isDefault == 1) {
        return;
      }
    },
    //addAddress跳转新增地址
    addAddress() {
      this.$router.push({
        path: '/main/writeaddress'
      })
    },
    //设置默认地址api
    getDoSetDefaultAddress(addressId, isDefault) {
      this.doSetDefaultAddress([addressId, isDefault]).then(res => {
        this.getlistAddress(); //重新获取页面
        this.toast1 = true;
        setTimeout(() => { this.toast1 = false }, 1500)
      })
    },
    //删除收货地址api
    getRemoveAddress(addressId) {
      this.removeAddress(addressId).then(res => {
        this.isDelete = false;
        this.getlistAddress(); //重新加载页面
        this.toast2 = true;
        setTimeout(() => { this.toast2 = false }, 1500)
      }).catch(error => {

      })
    },
    getlistAddress() {
      let _this = this;
      //直接列出收货地址列表
      this.listAddress().then(res => {
        this.loadShow = false;
        this.listAddressMsg = res;
        this.listAddressMsg.forEach(function(item, index) {
          if (item.isDefault == 1) {
            _this.defaultAddress = item.addressId
          }
        })

      }).catch(error => {

      });
    },
  },
  watch: {},
  mounted() {
    this.getlistAddress();
  },
  components: {
    menus,
    myOrdersItem,
    empty
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';
.address-list {
  .address-item {
    @include font-dpr(14px);
    line-height: 1.5;
    padding: 0.4rem;
    background: #fff;
    margin-bottom: 0.4rem;
    .address {
      color: #666666;
    }
    .user {
      margin: 0.2rem 0;
      color: #000;
    }
    .operate {
      padding-top: 0.3rem;
      clear: both;
      @include font-dpr(12px);
      @include bdT(#e5e5e5, top);
      .primary {
        .mu-radio-wrapper {
          .mu-radio-icon {
            .mu-radio-svg-icon {
              color: #E60012;
            }
          }
          .mu-radio-label {
            color: #E60012;
          }
        }
      }
      .list-radio {
        height: 0.5rem;
        display: inline-block;
        .mu-radio-icon {
          .mu-radio-svg-icon {
            background-size: 0.4rem;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// myaddress.vue?52873c02